import ReactGA from 'react-ga';

export const initGA = () => {
    ReactGA.initialize(
        process.env.GA_TRACKING_ID /* put your tracking id here*/,
        {
            gaOptions: {},
        },
    );
};

export const GApageView = (page) => {
    ReactGA.pageview(page);
};

export const GAUserId = (userId) => {
    ReactGA.set({ userId });
};

export const GAevent = (
    action,
    category,
    label,
    value,
    nonInteraction = false,
) => {
    ReactGA.event({
        category, // Required
        action, // Required
        label,
        value,
        nonInteraction,
    });
};
